import React, { forwardRef } from 'react';

const AudioPlayer = forwardRef((props, ref) => {
  return (  
    <audio ref={ref} src={`/music/roy.mp3`} loop>
      Your browser does not support the audio tag.
    </audio>
  );
});

export default AudioPlayer;
